import React from 'react'

import TextEditor, { TEXT_EDITOR_MODES } from 'components/TextEditor/TextEditor'

class Block1 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            html: props.text,
            focused: false,
        }
    }

    render() {
        const {
            blockData: { t, wP_bg, isTransparentBackground },
            text,
            id,
            onUpdate,
        } = this.props

        return (
            <div
                className={`block __${t}`}
                style={{ backgroundColor: isTransparentBackground ? 'transparent' : wP_bg }}
            >
                <TextEditor
                    mode={TEXT_EDITOR_MODES.SEPARATE}
                    content={text}
                    onChange={html => {
                        onUpdate({
                            [id]: {
                                data: { text: html },
                            },
                        })
                    }}
                />
            </div>
        )
    }
}

export default Block1
